<template>
  <div>
    <div class="event-header">
      <div class="event-type">
        <i
          class="el-icon-warning"
          :style="{color: 'red'}"
        />
        <span class="event-type-text">{{ CardFunctions.formatEventType(event.event_type) }}</span>
        <el-tag
          :type="CardFunctions.getStatusType(event.status)"
          size="mini"
        >
          {{ event.status || '-' }}
        </el-tag>
      </div>
      <span class="event-time">
        <i class="el-icon-time" /> {{ CardFunctions.formatDate(event.created_at) }}
      </span>
    </div>

    <div class="event-resource">
      <div class="resource-name">
        Consignment: {{ event.resource.consignment.con_full }}
      </div>
      <div class="resource-id">
        Carrier: {{ CardFunctions.formatValue(event.resource.consignment.carrier.carrier_name) }} <br>
        Status: {{ CardFunctions.formatValue(event.resource.level.name) }}
      </div>
    </div>

    <div
      v-if="event.data && Object.keys(event.data).length > 0"
      class="event-data"
    >
      <div
        v-for="(value, key) in event.data"
        :key="key"
        class="data-item"
      >
        <span class="data-label">{{ CardFunctions.formatKey(key) }}:</span>
        <span>{{ CardFunctions.formatValue(value) }}</span>
      </div>
    </div>

    <div class="event-actions">
      <router-link
        :to="{ name: 'freight-consignments-v3-consignment-details', params: { consignmentId: event.resource_uuid } }"
      >
        Open Consignment
      </router-link>
    </div>
  </div>
</template>
<script>
import CardFunctions from '@/components/Application/Feed/Cards/CardFunctions'

export default {
  name: 'TrackingTimeslotCard',
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    CardFunctions () {
      return CardFunctions
    }
  }
}
</script>
